module.exports = __webpack_public_path__ + "static/media/satish_ram.fa05cd91.svg";